(function(angular, $) {
    'use strict';

    angular.module('wtUi.wtDotsDropdown').component('wtDotsDropdown', {
        controller: WtDotsDropdownFn,
        controllerAs: 'wtDotsDropdown',
        templateUrl: 'src/dropdown/dots-dropdown/dots-dropdown.component.html',
        transclude: true,
        bindings: {
            dropdownItems: '<?',
            active: '<?',
            onAction: '&?',
            displayName: '@?',
            title: '@?',
            inlineTemplate: '@?'
        }
    });

    WtDotsDropdownFn.$inject = ['$element', '$rootScope', '$scope'];

    function WtDotsDropdownFn($element, $rootScope, $scope) {
        class WtDotsDropdown {
            constructor() {
                this.isOpen = false;
            }
            $onInit() {
                this.dropdownHandler_ = this.dropdownHandler.bind(this);
                this.displayName = this.displayName || 'name';
                this.hasItems = this.dropdownItems && this.dropdownItems.length;
                // we need a window object that is outside of angular world
                this.$windowEl = $(window);

                this.closeHandler = $rootScope.$on('wtDotsDropdown:closeOthers', () => {
                    if (this.isOpen) {
                        this.isOpen = false;
                    }
                });

                if (!this.inlineTemplate) {
                    this.idInfix = $element.attr('class')
                        .replace('wt-dots-dropdown', '')
                        .replace(/ng.*-scope/, '')
                        .replace(/ /g, '');
                }
            }

            $onChanges(changes) {
                if (changes.dropdownItems && changes.dropdownItems.currentValue) {
                    this.hasItems = changes.dropdownItems.currentValue.length;
                }
            }

            $onDestroy() {
                this.closeHandler();
            }

            /**
             * toggles dropdown
             */
            toggleDropdown() {
                if (this.isOpen === false) {
                    // send close other dropdowns
                    $rootScope.$emit('wtDotsDropdown:closeOthers');
                    this.$windowEl.on('click', this.dropdownHandler_);
                } else {
                    this.$windowEl.off('click', this.dropdownHandler_);
                }

                this.isOpen = !this.isOpen;
            }

            /**
             * handles closing of the dropdown on click outside of it
             * @param {Object} event - click event obj
             */
            dropdownHandler(event) {
                if (!event.target) {
                    return;
                }

                const isChild = $element.has(event.target).length > 0;
                if (!isChild) {
                    /* eslint callback-return:0 */
                    this.closeDropdown();
                }
            }

            /**
             * closes dropdown (outside of angular world, thus apply)
             */
            closeDropdown() {
                this.isOpen = false;
                this.$windowEl.off('click', this.dropdownHandler_);
                $scope.$apply();
            }

            /**
             * Constructs the data-qa attribute
             * @param {String} title
             */
            makeQaAttribute(title) {
                return `top-nav__link--${title.split(' ').join('')}`;
            }
        }

        return new WtDotsDropdown();
    }
})(window.angular, window.$);

